<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="image"><a id="page_19"></a><img alt="Image" src="images/flower.jpg"/></p>
<h2 class="h2"><a id="chapter02"></a><span class="smallcaps">TWO</span></h2>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><strong><span class="smallcaps">LINGERING VESTIGES OF THE</span></strong> customs against which I rebel still plague me. Perhaps you can begin to comprehend what an effort it is for me to frame my sentences in this style, to twist my verbs around in order to fit the first-person construction. I have been writing ten minutes and my body is covered with sweat, not the hot sweat of the burning air about me but the dank, clammy sweat of mental struggle. I know the style I must use, but the muscles of my arm rebel against me, and fight to put down the words in the old fashion, saying, <em>One has been writing for ten minutes and one’s body is covered with sweat,</em> saying, <em>One has passed through a time of changes, and he has been healed of the sickness that affects those who inhabit his world.</em> I suppose that much of what I have written could have been phrased in the old way, and no harm done; but I do battle against the self-effacing grammar of my world, and if I must, I will joust with my own muscles for the right to arrange my words according to my present manner of philosophy.</p>
<p class="indent-para">In any case, however my former habits trick me into mis-constructing my sentences, my meaning will blaze through the screen of words. I may say, “I am Kinnall Darival and I mean to tell you all about myself,” or I may say, “One’s name is Kinnall <a id="page_20"></a>Darival and he means to tell you all about himself,” but there is no real difference. Either way, the content of Kinnall Darival’s statement is—by your standards, by the standards I would destroy—disgusting, contemptible, obscene.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?659fc2ab